import { render, staticRenderFns } from "./ed-course-template.component.vue?vue&type=template&id=3ad5e386&scoped=true&"
import script from "./ed-course-template.component.ts?vue&type=script&lang=ts&"
export * from "./ed-course-template.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-course-template.component.scss?vue&type=style&index=0&id=3ad5e386&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad5e386",
  null
  
)

export default component.exports